import { SplideSlide } from '@splidejs/react-splide'
import map from 'lodash/map'
import React, { memo, useMemo, VFC } from 'react'
import styled from 'styled-components'

import { RelatedProduct } from '@Components/Product/RelatedProducts/index'
import { ProductTile } from '@Components/Product/Tile'
import { ContainerSlider } from '@Components/Slider/ContainerSlider'
import { getProductTilesFromRelatedProducts } from '@Globals/CMS/ProductHelpers'
import { up } from '@Globals/Style/breakpoints'
import appTheme from '@Globals/Style/theme'
import { useMediaQuery } from '@Globals/useMediaQuery'

const RelatedDesktopList = styled.div(() => `
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(5, minmax(0, 1fr));

  > *:nth-child(n+16) {
    display: none;
  }

  ${up('wide')} {
    grid-template-columns: repeat(6, minmax(0, 1fr));

    > *:nth-child(n+16) {
      display: block;
    }
  }
`)

type ListProps = {
  products?: RelatedProduct[]
}

export const RelatedProductsList: VFC<ListProps> = memo(({ products }) => {
  const enableSlider = !useMediaQuery(`(min-width: ${appTheme.breakpoints.mobileStyleThreshold})`)
  const isPhablet = useMediaQuery(`(min-width: ${appTheme.breakpoints.phablet})`)
  const transformedProducts = useMemo(
    () => {
      const mappedData = getProductTilesFromRelatedProducts(products)
      return map(mappedData, ProductTile)
    },
    [products],
  )

  if (enableSlider) {
    const perPage = isPhablet ? 3 : 2

    return (
      <ContainerSlider
        options={{
          arrows: false,
          drag: true,
          breakpoints: undefined,
          fixedWidth: `${Math.floor(100 / perPage) - 5}%`,
          gap: appTheme.padding.phablet,
          padding: appTheme.padding.phablet,
          pagination: false,
          perMove: perPage,
          perPage,
          width: '100%',
        }}
      >
        {map(transformedProducts, (item, productIndex) => (
          <SplideSlide key={productIndex}>
            {item}
          </SplideSlide>
        ))}
      </ContainerSlider>
    )
  }

  return (
    <RelatedDesktopList>
      {transformedProducts}
    </RelatedDesktopList>
  )
})
